module.exports = __webpack_public_path__ + "media/images/icons/country_flags/lb-542b007bb3f7b6a54526e0cd4b988a57.svg";